import { StationNavigatorBreadcrumb } from '@app/components/base/stations/StationNavigatorBreadcrumb';
import { Page } from '@app/components/page/Page';
import { useActiveStation } from '@app/core/stations/hooks/useActiveStation';
import { SearchModule } from '@app/modules/search';
import { Alert, AlertTitle } from '@mui/material';
import { useIntl } from 'react-intl';
import { SearchIcon } from '../../SearchIcon';
import { SearchView } from './SearchView';

export function SearchPage() {
  const station = useActiveStation();
  const { $t } = useIntl();

  const transcriptEnabled = station.featuresConfig?.transcription.enabled;

  const title = $t({
    id: 'search.title',
    defaultMessage: 'Búsqueda',
  });

  return (
    <Page htmlTitle={`${title} | ${station.name}`}>
      <Page.Header
        icon={<SearchIcon />}
        title={[
          title,
          <StationNavigatorBreadcrumb
            key={station.id}
            basePath={SearchModule.basePath}
            activeId={station.id}
          />,
        ]}
      />
      {transcriptEnabled ? (
        <SearchView station={station} />
      ) : (
        <Page.Content>
          <Alert severity="warning">
            <AlertTitle>
              {`${$t({
                id: 'search.featureNotAvailable',
                defaultMessage: 'No disponible para ',
              })} ${station.name}`}
            </AlertTitle>
            {$t({
              id: 'search.contactAdmin',
              defaultMessage: 'Contacte a soporte para activar esta funcionalidad.',
            })}
          </Alert>
        </Page.Content>
      )}
    </Page>
  );
}
